import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import './ErrorMessage.scss';

interface IErrorMessageProps {
    message?: string;
    dataCy?: string;
}

export const ErrorMessage: FunctionComponent<IErrorMessageProps> = function ({ message, dataCy }) {
    const { t, i18n } = useTranslation();
    return (
        <p className="errorMessage" data-cy={dataCy}>
            <FontAwesomeIcon icon="exclamation-triangle" className="errorMessage_icon" />
            {message}
        </p>
    );
}



